import {
  CircularProgress,
  Grid,
  GridProps,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import i18n from 'i18n';
import React from 'react';
import { StatusIcon } from 'components/TableItems';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface Props {
  type: 'active' | 'started' | 'removing' | 'close';
  gridProps?: GridProps;
}

const ScreenState = ({ type, gridProps }: Props) => {
  const classes = useStyles();

  const RenderItem = {
    active: (
      <Tooltip placement="top" arrow title={i18n.t('ACTIVE_KEY')}>
        <Grid container justify="center">
          <StatusIcon status="success" />
        </Grid>
      </Tooltip>
    ),
    init: (
      <Tooltip placement="top" arrow title={i18n.t('STARTED_KEY')}>
        <img
          className={classes.iconStarted}
          src="/images/refresh_icon.svg"
          alt="refresh_icon"
        />
      </Tooltip>
    ),
    close: (
      <Tooltip placement="top" arrow title={i18n.t('CLOSED_KEY')}>
        <Grid container justify="center">
          <StatusIcon status="blocked" />
        </Grid>
      </Tooltip>
    ),
    removing: (
      <Tooltip placement="top" arrow title={i18n.t('REMOVING_KEY')}>
        <CircularProgress size={15} color="secondary" />
      </Tooltip>
    ),
  };

  return (
    <React.Fragment>
      <Grid
        className={classes.container}
        container
        {...gridProps}
        data-testid={'autosky-screenstate'}
      >
        {RenderItem[type]}
      </Grid>
    </React.Fragment>
  );
};

export default ScreenState;
